<template>
  <header
    id="app-header"
    style="
      width:100%;
      height:5rem;
      background-color: black;
      /* display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: black;
      color:white; */
      /* padding-left:20%;
      padding-right: 20%; */
      "
  >
    <Container :boundsInnerStyles="{ 'padding-top': '0', 'padding-bottom': '0' }">
      <div
        style="
        width:100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: black;
        color:white;
        min-width: 480px;
        height:5rem;
        "
      >
        <img v-if="feed.logo" :src="feed.logo" style="width: 5rem;" />
        <div v-else style="font-size: 3rem; font-weight: bold;">{{ feed.name }}</div>
        <div style="width: 3rem;"></div>
        <div>{{ feed.description }}</div>
        <!-- <div>{{ JSON.stringify(feed) }}</div> -->
      </div>
    </Container>
  </header>
</template>

<script>
import UserProfileDropdown from '@/components/user/UserProfileDropdown';
import InfoHeaderBanner from '@/components/InfoHeaderBanner';
import Container from '@/components/Container';

import { chatInit } from '../services/chatHelper.js';
export default {
  name: 'WhiteLabelFeedHeaderbar',
  components: {
    UserProfileDropdown,
    InfoHeaderBanner,
    Container
  },
  props: {
    feed: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      name: 'TITLE',
      logo: 'https://cdn-images-1.medium.com/max/580/1*tcwKu6vxKEi6FDDOgKCWnA@2x.png',
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it"
    };
  },
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>

<style lang="scss">
#app-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
</style>
